import { IconProps } from './Icon.types';
import { ICON_MAP, ICON_SIZE_MAP } from './Icon.constants';
import { useStyles } from './Icon.styles';
import { useColor } from '../../hooks/useColor';

export const Icon = ({
  name,
  title,
  color = 'primary',
  size = 'md',
  variant = 'action',
  fill = 'transparent',
  ...rest
}: IconProps) => {
  const styles = useStyles({ variant });
  const iconColor = useColor({ color });
  const iconFillColor = useColor({ color: fill });

  const IconComponent = ICON_MAP[name];
  const iconSize = ICON_SIZE_MAP[size];

  return (
    <IconComponent
      role="img"
      title={title}
      style={styles.icon}
      size={iconSize}
      color={iconColor}
      fill={iconFillColor}
      {...rest}
    />
  );
};
